"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsAttributes = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const react_window_1 = require("react-window");
const product_details_attribute_list_row_component_1 = require("./product-details-attribute-list-row.component");
const product_details_attributes_constants_1 = require("./product-details-attributes.constants");
const product_details_attributes_styles_1 = require("./product-details-attributes.styles");
const attributes_1 = require("../../../constants/attributes");
const store_1 = require("../../../../store");
const formatValue = (value, unit) => `${value}${unit && unit !== product_details_attributes_constants_1.UNSPECIFIED_UNIT ? ` ${unit}` : ''}`;
const formatAttributions = (attributions) => {
    const attributesMap = new Map();
    attributions.forEach((attribution) => {
        const { label, value: unformattedValue, unit, isValid = false, origin, } = attribution;
        if (attributes_1.CATEGORY_DEFAULT_ENRICHED_ATTRIBUTES.includes(label)) {
            return;
        }
        const existingAttribute = attributesMap.get(label);
        const value = formatValue(unformattedValue, unit);
        const newItem = {
            value,
            valid: isValid,
            unit,
            origin,
        };
        if (!existingAttribute) {
            const newAttribute = {
                label,
                isEditable: (isValid && !unit) || value === attributes_1.SpecialAttributeValue.Unknown,
                selectedValues: [newItem],
            };
            attributesMap.set(label, newAttribute);
        }
        else {
            existingAttribute.selectedValues.push(newItem);
        }
    });
    return Array.from(attributesMap.values());
};
const ProductDetailsAttributes = ({ productId, productTreeNodeId, isLocked, productEnrichedAttributions, productOriginalAttributions, }) => {
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    const sizeMap = (0, react_1.useRef)([]);
    const listRef = (0, react_1.useRef)();
    const formattedAttributions = (0, react_1.useMemo)(() => formatAttributions(productEnrichedAttributions.concat(productOriginalAttributions)), [productEnrichedAttributions, productOriginalAttributions]);
    const sortedAttributions = (0, react_1.useMemo)(() => (0, ramda_1.sortWith)([
        (0, ramda_1.comparator)((a, b) => {
            const aMatch = selectedAttributeNode && a.label === selectedAttributeNode.label;
            const bMatch = selectedAttributeNode && b.label === selectedAttributeNode.label;
            return aMatch && !bMatch;
        }),
        (0, ramda_1.comparator)((a, b) => a.isEditable && !b.isEditable),
        ({ label: a }, { label: b }) => a.localeCompare(b),
    ], formattedAttributions), [formattedAttributions, selectedAttributeNode]);
    const setSize = (0, react_1.useCallback)((index, size) => {
        sizeMap.current = Object.assign(Object.assign({}, sizeMap.current), { [index]: size });
        listRef.current.resetAfterIndex(index);
    }, []);
    const getSize = (index) => sizeMap.current[index] || product_details_attribute_list_row_component_1.LIST_ITEM_HEIGHT;
    return (react_1.default.createElement(product_details_attributes_styles_1.StyledWrapper, null, react_1.default.createElement(react_virtualized_auto_sizer_1.default, null, ({ width, height }) => (react_1.default.createElement(react_window_1.VariableSizeList, { height: height, width: width, ref: listRef, itemKey: (index, data) => data.items[index].label, estimatedItemSize: product_details_attribute_list_row_component_1.LIST_ITEM_HEIGHT, itemSize: getSize, itemCount: sortedAttributions.length, itemData: {
            productId,
            productTreeNodeId,
            isLocked,
            items: sortedAttributions,
            setSize,
        } }, product_details_attribute_list_row_component_1.ProductDetailsAttributeListRow)))));
};
exports.ProductDetailsAttributes = ProductDetailsAttributes;
